export default {
    title: "Contact Requests",
    subtitle: "Manage inquiries received from the website contact form",
    view: "View Request",
    delete: "Delete Request",
    table: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        status: "Status",
        createdAt: "Received At",
        actions: "Actions"
    },
    status: {
        read: "Read",
        unread: "Unread"
    },
    breadcrumbs: {
        contactRequests: "Contact Requests"
    },
    messages: {
        fetchError: "Failed to fetch contact requests",
        deleteConfirm: "Are you sure you want to delete this inquiry?",
        deleteSuccess: "Contact request deleted successfully",
        deleteError: "Failed to delete contact request",
        noRequests: "No contact requests found"
    }
};
